export default __webpack_public_path__ + "static/media/roomservice.515bf961.svg";